import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Checkbox from "@mui/material/Checkbox";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Paper from "@mui/material/Paper";
import Select from "@mui/material/Select";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { useEffect, useState, useRef } from "react";
import {
  MODULE_URL,
  ROLES_SCREENS_BY_ROLE_URL,
  ROLES_SCREENS_URL,
  ROLES_URL,
  SCREENS_URL,
} from "../../../Constants/Constants";
import AxiosInstance from "../../../services/AxiosInstance";
import { ThemeProvider } from "../../v2/home/theme/ThemeProvider";

function RoleAccess() {
  const [rolesData, setRolesData] = useState([]);
  const [screensData, setScreensData] = useState([]);
  const [modulesData, setModulesData] = useState([]);
  const [roleScreensData, setRoleScreensData] = useState([]);
  const [screenValues, setScreenValues] = useState({});

  const [role, setRole] = useState([]);
  const [roleScreen, setRoleScreen] = useState({
    role: { id: "" },
    screens: { id: "" },
    menu: false,
    create: false,
    edit: false,
    delete: false,
    view: false,
  });

  useEffect(() => {
    getRoles();
    getModules();
    getScreens();
  }, []);

  const getRoles = () => {
    AxiosInstance.get(ROLES_URL).then((response) =>
      setRolesData(response.data.data)
    );
  };

  const getScreens = () => {
    AxiosInstance.get(SCREENS_URL).then((response) =>
      setScreensData(response.data)
    );
  };

  const getRoleScreens = (roleId) => {
    AxiosInstance.get(`${ROLES_SCREENS_BY_ROLE_URL}/${roleId}`).then((response) =>
      setRoleScreensData(
        response.data.data.map((roleScreen) => {
          setScreenValues(prev => ({
            ...prev,
            ["role_screen_id_exist_" + roleScreen.screens.id]: "Y"
          }));

          if (roleScreen.menu)
            document.getElementById("menu_" + roleScreen.screens.id).click();
          if (roleScreen.add)
            document.getElementById("add_" + roleScreen.screens.id).click();
          if (roleScreen.edit)
            document.getElementById("edit_" + roleScreen.screens.id).click();
          if (roleScreen.delete)
            document.getElementById("delete_" + roleScreen.screens.id).click();
          if (roleScreen.view)
            document.getElementById("view_" + roleScreen.screens.id).click();
          if (
            roleScreen.menu &&
            roleScreen.add &&
            roleScreen.edit &&
            roleScreen.delete &&
            roleScreen.view
          )
            document.getElementById("all_" + roleScreen.screens.id).click();
        })
      )
    );
  };

  const getModules = () => {
    AxiosInstance.get(MODULE_URL).then((response) =>
      setModulesData(response.data)
    );
  };

  const handleRoleChange = (event) => {
    setRole(event.target.value);
    uncheckElements();
    getRoleScreens(event.target.value);
  };

  function uncheckElements() {
    var uncheck = document.getElementsByTagName("input");
    for (var i = 0; i < uncheck.length; i++) {
      if (uncheck[i].type === "checkbox") {
        if (uncheck[i].checked) uncheck[i].click();
      }
    }
  }

  const onSelectAllClick = (event) => {
    var screenId = event.target.id.replace("all_", "");
    if (event.target.checked) {
      if (!document.getElementById("menu_" + screenId).checked)
        document.getElementById("menu_" + screenId).click();
      if (!document.getElementById("add_" + screenId).checked)
        document.getElementById("add_" + screenId).click();
      if (!document.getElementById("edit_" + screenId).checked)
        document.getElementById("edit_" + screenId).click();
      if (!document.getElementById("delete_" + screenId).checked)
        document.getElementById("delete_" + screenId).click();
      if (!document.getElementById("view_" + screenId).checked)
        document.getElementById("view_" + screenId).click();
    } else {
      if (document.getElementById("menu_" + screenId).checked)
        document.getElementById("menu_" + screenId).click();
      if (document.getElementById("add_" + screenId).checked)
        document.getElementById("add_" + screenId).click();
      if (document.getElementById("edit_" + screenId).checked)
        document.getElementById("edit_" + screenId).click();
      if (document.getElementById("delete_" + screenId).checked)
        document.getElementById("delete_" + screenId).click();
      if (document.getElementById("view_" + screenId).checked)
        document.getElementById("view_" + screenId).click();
    }
  };

  const handleSaveScreen = (event) => {
    roleScreen.role.id = role;
    roleScreen.screens.id = event.target.id;
    roleScreen.menu = document.getElementById(
      "menu_" + event.target.id
    ).checked;
    roleScreen.add = document.getElementById("add_" + event.target.id).checked;
    roleScreen.edit = document.getElementById(
      "edit_" + event.target.id
    ).checked;
    roleScreen.delete = document.getElementById(
      "delete_" + event.target.id
    ).checked;
    roleScreen.view = document.getElementById(
      "view_" + event.target.id
    ).checked;

    var isUpdateRequest = ((screenValues["role_screen_id_exist_" + event.target.id] || "N")) === "Y" ? true : false;
    
    if (isUpdateRequest) {
      AxiosInstance.put(ROLES_SCREENS_URL, roleScreen)
        .then((response) => {
          alert("Role access updated successfully!");
        })
        .catch((error) => {
          alert("Role access updation failed!");
          console.error(error);
        });
    } else {
      AxiosInstance.post(ROLES_SCREENS_URL, roleScreen)
        .then((response) => {
          alert("Role access saved successfully!");
        })
        .catch((error) => {
          alert("Role access creation failed!");
          console.error(error);
        });
    }
  };

  const handleSaveAll = (event) => {
    alert("Need to implement this functionality!");
    screensData.map((screen) => { });
  };

  return (
    <ThemeProvider>
      <>
        <Box
          component="form"
          sx={{ "& .MuiTextField-root": { m: 1, width: "50ch" } }}
          noValidate
          autoComplete="off"
        >
          <FormControl variant="outlined" sx={{ m: 1, minWidth: 200 }}>
            <InputLabel id="demo-simple-select-standard-label">Role</InputLabel>
            <Select
              labelId="demo-simple-select-standard-label"
              id="demo-simple-select-standard"
              value={role}
              onChange={handleRoleChange}
              label="Role"
            >
              <MenuItem value="">
                {" "}
                <em>None </em>{" "}
              </MenuItem>
              {rolesData.map((role) => (
                <MenuItem value={role.id}>{role.name}</MenuItem>
              ))}
            </Select>
          </FormControl>

          <Button
            variant="outlined"
            onClick={handleSaveAll}
            style={{ float: "right", marginRight: "5px" }}
          >
            Save All
          </Button>
        </Box>
        <br />
        <TableContainer component={Paper}>
          <Table sx={{ minWidth: 650 }} aria-label="simple table">
            <TableHead>
              <TableRow>
                <TableCell>&nbsp;</TableCell>
                <TableCell align="right">Menu</TableCell>
                <TableCell align="right">Add</TableCell>
                <TableCell align="right">Edit</TableCell>
                <TableCell align="right">Delete</TableCell>
                <TableCell align="right">View</TableCell>
                <TableCell align="right">All</TableCell>
                <TableCell align="right">&nbsp;</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {modulesData.map((module) => (
                <>
                <TableRow
                  key={module.name}
                  sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                >
                  <TableCell
                    component="th"
                    scope="row"
                    colSpan={8}
                    style={{ backgroundColor: "gray" }}
                  >
                    {module.name}
                  </TableCell>
                </TableRow>

                  {screensData.map((screen) => {
                  if (module.id === screen.module.id) {
                    return (
                      <TableRow
                        key={screen.name}
                        sx={{
                          "&:last-child td, &:last-child th": { border: 0 },
                        }}
                        id={"row_" + screen.id}
                      >
                        <TableCell component="th" scope="row">
                          {screen.name}
                          <input
                            type="hidden"
                            value={screenValues["role_screen_id_exist_" + screen.id] || "N"}
                            readOnly
                          />


                        </TableCell>
                        <TableCell align="right">
                          <Checkbox
                            color="primary"
                            id={"menu_" + screen.id}
                          // onChange={onSelectAllClick}
                          />
                        </TableCell>
                        <TableCell align="right">
                          <Checkbox
                            color="primary"
                            id={"add_" + screen.id}
                          // onChange={onSelectAllClick}
                          />
                        </TableCell>
                        <TableCell align="right">
                          <Checkbox
                            color="primary"
                            id={"edit_" + screen.id}
                          // onChange={onSelectAllClick}
                          />
                        </TableCell>
                        <TableCell align="right">
                          <Checkbox
                            color="primary"
                            id={"delete_" + screen.id}
                          // onChange={onSelectAllClick}
                          />
                        </TableCell>
                        <TableCell align="right">
                          <Checkbox
                            color="primary"
                            id={"view_" + screen.id}
                          // onChange={onSelectAllClick}
                          />
                        </TableCell>
                        <TableCell align="right">
                          <Checkbox
                            color="primary"
                            id={"all_" + screen.id}
                            onChange={onSelectAllClick}
                          />
                        </TableCell>
                        <TableCell align="right">
                          {/* <Button variant="outlined" onClick={handleClickOpen} style={{float:"right", margin:"5px"}}></Button> */}
                          <Button
                            id={screen.id}
                            variant="outlined"
                            onClick={handleSaveScreen}
                            style={{ float: "right", margin: "5px" }}
                          >
                            Save
                            </Button>
                        </TableCell>
                      </TableRow>
                    );
                  }
                })
                }
                </>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </>
    </ThemeProvider>
  );
}
export default RoleAccess;
